// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.for-drop-down-menu {
  width: 250px !important;
  padding-top: 30px !important;
  padding-left: 20px !important;
}

.for-sidebar-layout {
  display: flex;
  margin-left: 10px;
}

.for-sidebar-layout-suv {
  display: flex;
  margin-left: -12px;
  margin-top: 15px;
  margin-bottom: -20px;
}

.switch3 {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch3 input {
  opacity: 0;
  width: 0;
  height: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/AppLayout/SettingsDropdown/styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,4BAAA;EACA,6BAAA;AACF;;AAGA;EACE,aAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAAF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AADF","sourcesContent":[".for-drop-down-menu {\n  width: 250px !important;\n  padding-top: 30px !important;\n  padding-left: 20px !important;\n}\n\n\n.for-sidebar-layout {\n  display: flex;\n  margin-left: 10px;\n}\n\n.for-sidebar-layout-suv {\n  display: flex;\n  margin-left: -12px;\n  margin-top: 15px;\n  margin-bottom: -20px;\n}\n\n\n.switch3 {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch3 input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
